import { render, staticRenderFns } from "./CopyMoveCalendarModal.vue?vue&type=template&id=7c80b966&scoped=true&"
import script from "./CopyMoveCalendarModal.vue?vue&type=script&lang=js&"
export * from "./CopyMoveCalendarModal.vue?vue&type=script&lang=js&"
import style0 from "./CopyMoveCalendarModal.vue?vue&type=style&index=0&id=7c80b966&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c80b966",
  null
  
)

export default component.exports